import { render, staticRenderFns } from "./AlarmQueueHeader.vue?vue&type=template&id=0b0f995e&scoped=true"
import script from "./AlarmQueueHeader.vue?vue&type=script&lang=ts"
export * from "./AlarmQueueHeader.vue?vue&type=script&lang=ts"
import style0 from "./AlarmQueueHeader.vue?vue&type=style&index=0&id=0b0f995e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f995e",
  null
  
)

export default component.exports